// work data

export const Work = [
    {
        id:1,
        name:"Reward Eagle",
        description:"I developed Reward Eagle, a website rewarding users with coupon codes for online shopping, handling React frontend and Node.js backend.",
        tags:["react","MongoDB","Node.js","Express"],
        
        demo:"https://rewardeagle.com/",
        //github:"https://github.com/codebucks27/Agency-website"
    },
    {
        id:2,
        name:"Susasthya",
        description:"A health care website build on top of Wordpress using Divi",
        tags:["Wordpress","Divi"],
        
        demo:"http://susasthya.com/",
        //github:"https://github.com/codebucks27/react-job-listing-website"
        
    },
    // {
    //     id:3,
    //     name:"Dev.to Clone",
    //     description:"A clone of Dev.to build using ReactJS. With realtime fetching of articles from dev.to using API.",
    //     tags:["react","api","sass"],
        
    //     demo:"http://devto-clone-codebucks27.vercel.app/",
    //     github:"https://github.com/codebucks27/devto-clone"
    // },
    // {
    //     id:4,
    //     name:"Sidebar Menu",
    //     description:"A cool looking sidebar menu build using ReactJS and styledComponents.It has really smooth animations.",
    //     tags:["react","styledComponents","react-router"],
        
    //     demo:"https://react-sidebar.vercel.app/",
    //     github:"https://github.com/codebucks27/react-sidebar"
       
    // },{
    //     id:5,
    //     name:"Todo App(React + Redux)",
    //     description:"A todo app build using Redux-toolkit and framer-motion for smooth animations.",
    //     tags:["react","redux","framer-motion"],
        
    //     demo:"http://react-redux-todo-app-git-main-codebucks27.vercel.app/",
    //     github:"https://github.com/codebucks27/React-Redux-Todo-App"
        
    // },
    // {
    //     id:6,
    //     name:"Responsive Navigation Menu",
    //     description:"A reponsive navbar menu component in ReactJS with react-router functionalities. Built from scratch.",
    //     tags:["react","react-router","css"],
        
    //     demo:"http://react-responsive-navbar-codebucks27.vercel.app/",
    //     github:"https://github.com/codebucks27/React-responsive-navbar"
        
    // },
    
  
] 